import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../shared/assets';
import { ContentfulImage } from '../Contentful';
import './RestaurantBanner.css';

interface RestaurantBannerProps {
  property?: string;
}

const RestaurantBanner: React.FC<RestaurantBannerProps> = ({ property = "patagonia" }) => {
  // Get property-specific content
  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'iguazu':
        return {
          title: "Immerse yourself in the Atlantic Rainforest where nature creates its own symphony.",
          description: "After days exploring waterfalls, jungle trails, and indigenous communities, return to Awasi Iguazú to enjoy conversations with fellow travelers and exquisite meals at our Relais & Châteaux restaurant. The perfect spot to experience the wonders of Misiones Province at your own pace.",
          cta: "SEE OUR LODGES"
        };
      case 'mendoza':
        return {
          title: "Experience the tranquility of Argentina's wine country at the foot of the majestic Andes Mountains.",
          description: "After days of wine tours, cooking classes, and mountain adventures, return to Awasi Mendoza to unwind in our spa and savor farm-to-table cuisine at our Relais & Châteaux restaurant. The perfect spot to enjoy Mendoza's wine country at your own pace surrounded by vineyards.",
          cta: "SEE OUR LODGES"
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: "Discover the serene beauty of Brazil's Emerald Coast, where pristine beaches meet the Atlantic Forest.",
          description: "After days of diving, motorboat excursions, and yoga sessions, return to Awasi Santa Catarina to relax in your private villa with heated pool and dine at our acclaimed restaurants. The perfect spot to experience the natural wonders of the Emerald Coast at your own pace.",
          cta: "SEE OUR LODGES"
        };
      case 'patagonia':
      default:
        return {
          title: "Step back from the rush of the 21st century into a place practically untouched by time, where nature rules and you feel the power of the elements. Ice and wind have shaped the landscape around you: stark peaks are circumnavigated by condors, and on the wide open plains pumas prowl and guanacos call out.",
          description: "After days exploring the steppe, mountains and glaciers, return to Awasi Patagonia for a drink by the fire and long evening meals at our Relais & Châteaux restaurant. The perfect spot to enjoy Torres del Paine National Park at your own pace with the comfort of a private reserve and your own villa.",
          cta: "SEE OUR LODGES"
        };
    }
  };
  
  const content = getContentForProperty();
  
  return (
    <div className="restaurant-banner">
      <ContentfulImage imageKey="restaurant-banner" fallbackSrc={images.restaurantBanner} alt="Restaurant" />
      <div className="banner-content">
        <h2>{content.title}</h2>
        <div className="banner-right">
          <p>{content.description}</p>
          <Link to="/destinations" className="link">{content.cta}</Link>
        </div>
      </div>
    </div>
  );
};

export default RestaurantBanner;
